import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';

import './VendorAttributionLabel.scss';

export default function VendorAttributionLabel({ name }) {
  return (
    <div className="cp-vendor-attribution-label">
      <span aria-hidden>{name}</span>
      <ScreenReaderMessage>
        <FormattedMessage id="sr_vendor_attribution_label" values={{ name }} />
      </ScreenReaderMessage>
    </div>
  );
}

VendorAttributionLabel.propTypes = {
  name: PropTypes.string
};
